export enum InvalidOrAbnormal {
  Invalid = 'Invalid',
  Abnormal = 'Abnormal',
}

export interface ApiListMetaResponse<C> {
  contents: Array<C>;
  metadata: ApiListMetadata;
}

export interface ApiListMetadata {
  totalCount: number;
  totalPageCount: number;
  size: number;
  lastId: string | null;
  hasNext?: boolean;
}

export interface ApiErrorResponse {
  code: number;
  message: string;
  errors?: Array<ApiErrorItem>;
}

export interface ApiErrorItem {
  domain: string;
  reason: string;
  message: string;
}

/**
 * 지원 기능 KR
 * @url /vehicles/{vin}
 * @type getVehicle
 */
export enum PermissionTypeKr {
  /** 보험 혜택 */
  UBI = 1,
  /** 차량인증등급 */
  CPO = 2,
  /** 소모품 */
  CONSUMABLES = 3,
  /** 차량진단 */
  DIAGNOSTICS = 4,
  /** 주행기록 (현재 사용하지않음) */
  TRIPS = 5,
  /** 안전운전점수 */
  SAFETY_SCORE = 6,
  /** 연비전비 (주행기록 feature) */
  TRIP_FUEL = 7,
  /** 브레이크패드 */
  BRAKE = 8,
  /** 타이어공기압 */
  TIRE = 9,
  /** 엔진오일 */
  ENGINE = 10,
  /** 배터리 */
  BATTERY_LOW = 11,
  /** 주유 */
  REFUEL = 12,
  /** 연비 */
  FUEL_EFFICIENCY = 13,
  /** EV BaaS */
  BATTERY_PFRM_MNG_DI_SERVICE = 14,
  /** 서울시에코마일리지 */
  SEOUL = 9001,
  /** 캐피탈1,2번 약관 동의 시 피처 */
  FINANCIAL_MANAGEMENT = 9002,
  /** 캐피탈3번 약관(제3자 동의) 동의 시 피처 */
  FINANCIAL_MANAGEMENT_3RD = 9003,
  /** EV 배터 현대 특화정보 */
  BATTERY_PFRM_MNG_SERVICE = 9004,
  /** 홈 최근주행기록 */
  HOME_RECENT = 10001,
  /** 주행기록 최근주행기록 */
  TRIPS_RECENT = 10002,
  /** 주행기록 설정 */
  TRIPS_SETTING = 10003,
}

/**
 * 지원 기능 EU
 * @url /vehicles/{vin}
 * @type getVehicleInfo
 */
export enum PermissionTypeEu {
  // ev에너지 사용정보
  EV_ENERGY_USAGE,
  // 주행기록
  TRIPS,
  // 안전운전 점수
  SAFETY_SCORE,
  // UBI 운전성향연동형보험
  UBI,
  // DI
  DI = 4,
}

/**
 * DI Case
 * @url /vehicles/{vin}
 * @type getVehicle
 */
export enum RoleType {
  NON_CCS = 1,
  UNREGISTERED_SPEC = 2,
  PRIMARY_USER = 3,
  SECONDARY_USER = 4,
}

/**
 * 연료 타입
 * @url /car/trip/driving-info
 * @type getMonthlyDrivingInfo
 */
export enum FuelType {
  G = 'G',
  D = 'D',
  L = 'L',
  E = 'E',
  H = 'H',
}

/**
 * 주행 설정
 * @url /vehicles/{vin}/settings/{settingType}
 * @type getVehicleSetting
 */
export enum SettingType {
  LOCK_DRIVE_RECORD = 'LOCK_DRIVE_RECORD',
  DISPLAY_FUEL_EFFICIENCY = 'DISPLAY_FUEL_EFFICIENCY',
}

/**
 * 주행 보조 장치
 * @url /cars/:vin/ccs-report
 * @type getCcsReport
 */
export enum AdasType {
  Y = 'Y',
  N = 'N',
}

/**
 * UBI
 * @url /third-party/ubi/cci/agreements
 * @type CreateUbiThirdpartyAgreementsCommnad
 */
export enum AgreeInfoType {
  SAFE_DRIVING_SCORE = '1',
  CONNECTED_SERVICES = '2',
  TOTAL_DISTANCE_TRAVELED = '3',
}

/**
 * UBI
 * @url /special-insurance-contract/insurance-discounts
 * @type GetInsuranceDiscountsResponse
 */
export enum DiscountType {
  CONNECTED_SERVICES = 'CONNECTED_SERVICES',
  SAFE_DRIVING_SCORE = 'SAFE_DRIVING_SCORE',
  TOTAL_DISTANCE_TRAVELED = 'TOTAL_DISTANCE_TRAVELED',
}

/**
 * 주행 이력 조회
 * @url /drive-history/trip
 * @type getTripHistoryByDate
 */
export enum TripOrderByType {
  DESC = 'DESC',
  ASC = 'ASC',
}

/**
 * 종합 인증 등급 조회
 * @url /cpo/grade
 * @type GetCpoGradeResponse
 */
export enum Grade {
  S = 'S',
  A = 'A',
  B = 'B',
  C = 'C',
  E = 'E',
}

export enum DetailGrade {
  S = 'S',
  'A+' = 'A+',
  A = 'A',
  'A-' = 'A-',
  B = 'B',
  C = 'C',
  E = 'E',
}

export enum VehicleInspectionRestrictionErrorCode {
  ALREADY_REGISTERED = 101, // 기등록
  MAXIMUM_REGISTERED = 102, // 최대 등록
  AUTHENTICATION_FAILED = 103, // 인증 실패
}
